import JoditEditor from "jodit-react";
import { useMemo, useRef } from "react";

const EditorComponent = ({ id, value, onChange, height, placeholder, disabled = false }) => {
    const editor = useRef(null);

    const config = useMemo(() => ({
        readonly: disabled,
        height: height || 250,
        maxHeight: 400,
        placeholder: placeholder || "Start typing here...",
        toolbarAdaptive: false,
        toolbarSticky: false,
        uploader: {
            insertImageAsBase64URI: true, // allow image upload
        },
        style: {
            backgroundColor: "#fff",
            fontSize: "16px",
        },
        buttons: [
            "bold",
            "italic",
            "underline",
            "|",
            "font",
            "fontsize",
            "brush",
            "paragraph",
            "|",
            "ul",
            "ol",
            "|",
            "align",
            "|",
            "link",
            "image",
            "|",
            "undo",
            "redo",
            "hr",
            "eraser",
        ],
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        toolbarButtonSize: 'small',
        askBeforePasteHTML: false,
    }), [height, placeholder, disabled]);

    return (
        <JoditEditor
            id={id}
            ref={editor}
            value={value}
            config={config}
            onBlur={(newContent) => onChange(newContent)}
        />
    );
};

export default EditorComponent;
